import React, { useEffect, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import DropdownComponent from '../dropdown/dropdown';
import { navLinksArray, navbarData } from './navbarData';
import gamitarLogo from '../../assets/gamitar-logo.svg';
import multisign from '../../assets/navbar/mult.png';
import bars from '../../assets/navbar/bars.png';
import { useTokenStore, useUserStore } from '../../store';

import styles from './navbar.module.scss';

const NavbarComponent = () => {
  const showAuthHeader = useTokenStore((s) => !s.accessToken);
  const [closemobilenav, setcloseMobileNav] = useState(false);
  const [active, setActive] = useState('');
  const [isCertified, setIsCertified] = useState();

  const handleClick = () => setcloseMobileNav(!closemobilenav);
  const closeMobileMenu = () => setcloseMobileNav(false);
  const user = useUserStore((s) => s.user);
  const closeOverlay = (e) => {
    if (closemobilenav) {
      e.stopPropagation();
    }
  };

  useEffect(() => {
    // /for testing suppose "testNew@gmail.com" is certified
    if (user.is_Certified) {
      setIsCertified(true);
    } else {
      setIsCertified(false);
    }
    return null;
  }, [user]);

  const check = (id) => {
    if (!isCertified && id === 'My Program') {
      return false;
    }
    return true;
  };

  return (
    <>
      <nav onClick={closeOverlay} className={styles['navigation-bar']}>
        <header>
          <Link to="/" onClick={closeMobileMenu}>
            <img className={styles['navigation-bar-logo']} src={gamitarLogo} alt="gamitar-logo" />
          </Link>
          <div className={styles['menu-icon']} onClick={handleClick}>
            {closemobilenav ? (
              <img src={multisign} alt="multisign" />
            ) : (
              <img src={bars} alt="bars" />
            )}
          </div>
        </header>
        <div
          className={`${styles.navoverlay} `}
          style={{ display: closemobilenav ? 'block' : 'none' }}
        />
        <ul className={`${styles['navigation-bar-menu']} ${closemobilenav ? styles.active : ''}`}>
          {!showAuthHeader &&
            navbarData.map((data) =>
              check(data.id) ? (
                <DropdownComponent
                  data={data}
                  active={active}
                  setActive={setActive}
                  key={data.id}
                />
              ) : null
            )}
          {showAuthHeader && (
            <>
              {navLinksArray.map((NavLinks) => (
                <li key={NavLinks} className={styles['navigation-bar-item']}>
                  <Link to="/" className={styles['navigation-bar-links']} onClick={closeMobileMenu}>
                    {NavLinks}
                  </Link>
                </li>
              ))}
            </>
          )}
        </ul>
      </nav>
    </>
  );
};

export default withRouter(NavbarComponent);
